import { useEffect } from 'react';
import { colorModeOf, colorsOf, tourCssVars } from '../theme/tour';
import { wearTheme } from '../theme/root';
// Dresses the whole page, navigation and footer included, in a tour's theme while one of the tour's
// views is mounted, and hands the page back to the community's colors on the way out. Null leaves the
// community's colors in place. Keyed on the theme object, so callers pass one that only changes with
// the theme.
export const useTourTheme = (theme) => {
    useEffect(() => {
        if (theme === null)
            return undefined;
        const colors = colorsOf(theme);
        return wearTheme({ vars: tourCssVars(colors), mode: colorModeOf(colors) });
    }, [theme]);
};
export default useTourTheme;
